import { render } from "./ForgotPasswordNew.vue?vue&type=template&id=6e7221a3&scoped=true"
import script from "./ForgotPasswordNew.vue?vue&type=script&lang=js"
export * from "./ForgotPasswordNew.vue?vue&type=script&lang=js"

import "./ForgotPasswordNew.vue?vue&type=style&index=0&id=6e7221a3&scoped=true&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e7221a3"]])

export default __exports__